import {t} from "i18next";


const Header = (props) => {
  const {
    onSetPause,
    currentDay,
    currentTime,
    currentHunger,
    currentFatigue,
  } = props

 return <div className="header-bar">
    <div className='left-bar'>
      <button className="pause-button" onClick={() => onSetPause()}></button>
      <span> {currentDay} {t('header-march')} 2024 </span>
      <span> {currentTime.toString().length < 2 ? `0${currentTime}` : currentTime}:00 </span>
    </div>
    <div className='left-bar'>
      <span> {t('header-Hunger')}: {currentHunger}% [{t('header-H')}]</span>
      <span> {t('header-Fatigue')}: {currentFatigue}% [{t('header-F')}]</span>
    </div>
  </div>
}

export default Header